import router from './router';
import store from './store';
// import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { isLogged } from '@/utils/auth';
import getPageTitle from '@/utils/get-page-title';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

router.beforeEach(async(to, from, next) => {

  // start progress bar
  NProgress.start();
  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const isUserLogged = isLogged();

  if (isUserLogged) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' });
      NProgress.done();
    } else {

      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles =  store.getters.roles && store.getters.roles.length > 0; // tam thoi ko kiem tra role true; //

      if (hasRoles) {
        next();
      } else {
        console.log("User NO Roles !!");
        // remove token and go to login page to re-login
        await store.dispatch('user/resetToken');
        // redirect to no role screen
        next(`/login?redirect=${to.path}`);

        NProgress.done();
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.matched[0] ? to.matched[0].path : '') !== -1) {
      // in the free login whitelist, go directly

      // console.log("redirectPath: " + redirectPath);

      // next({ path: redirectPath });
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
